import React from 'react'
import { Table, Form } from "@q4us-sw/q4us-ui";
import {Application} from '../self-reg/index'
import {
    getFeConfig,
    visualize,
    visualizeWithFilters,
    visualizeWithFilter
} from "../api/api";
import {Button, Typography, Tag, Modal} from "antd";
import qs from 'query-string'
import TableDataSource from "../utils/TableDataSource";
import {TableV2, TableContext} from "@q4us-sw/q4us-ui/lib/TableV2";

import { useLocation } from 'react-router-dom'

export const ApplicationView = (props)=>{

    const location = useLocation();
    const [filters, setFilters] = React.useState({key: 1, payload: []})
    React.useEffect(()=>{
        const {state: {filter} = {}} = location || {}
        if(filter){
            setFilters({key: filters.key + 1, payload: filter})
        }
    },[location])
    const [ci, setComplete] = React.useState({
        id:-1,
        visible:false,
        data:{}
    });

    const onStateChange = async ()=>{
        setComplete({id: -1, visible: false, data: {}});
    }

    return <React.Fragment>
        <Form
        schema={'opfe_self_registration_filter'}
        layout={'inline'}
        acceptText={'Filter'}
        rejectText={'Clear'}
        initialValue={(filters.payload || []).reduce((acc,{key,value})=>({...acc, [key]: value}),{})}
        disableAccept={true}
        config={async (schema)=>{
            const res = await getFeConfig(schema) || {}
            const {data: {rows =[]} = {}} = res;
            return rows;
        }}
        rejected={()=>{
            setFilters({key: filters.key +1, payload: []});
        }}
        validateField={async  (rule, value, schema, column, form) =>{
            if(column.name === 'id'){
                const val = form.getFieldsValue(['id']) || {};
                if(val['id'] < 0)
                    return Promise.reject(
                        'Enter valid a ID' 
                    )
            }
            return Promise.resolve()
        }}
        submit={(values)=>{
            const activeFilters = Object.entries(values).filter(([k,v])=>(v!=null&&v!=='')).map(([key,value])=>{
                if(typeof(value)==='string'){
                    value = value.trim();
                }
                if(key==='name'){
                    return {key: 'name',value: value, comparator: 'contains'}
                }
                return {key, value};
            })
            setFilters({key: filters.key +1, payload: activeFilters});
        }}
        />
        {filters.key && <TableV2
            key={filters.key}
            schema={"self_registration"}
            fetchConfig={async (schema)=>{
                const {data= {}} = await getFeConfig(schema)
                const { statusCode, rows = [], fields = [] } = data;
                const rows2 = rows.map(x => {
                    if (x.name === "status") {
                        const formatter = (row, index, name, type, enums, value) =>{
                            return <Typography.Text>{row['status'] ? <Tag color={'green'}>{row['status']}</Tag> : <Tag color={'red'}>PENDING</Tag>}</Typography.Text>
                        }
                        return {...x, formatter}
                    }
                    if (x.name === "id") {
                        const formatter = (row, index, name, type, enums, value) =>{
                            return <Typography.Text>{`${`${row.id}`.padStart(6,'0')}`}</Typography.Text>
                        }
                        return {...x, formatter}
                    }
                    return x
                });
                if(schema === 'self_registration') {
                    rows2.unshift({
                        dataIndex: "id",
                        title: "",
                        width: 120,
                        formatter: (row, index, name, type, formatted, value) => {
                            return <Button size={'small'} onClick={async ()=>{
                                const {data:{rows:self_reg_establishment}} = await visualizeWithFilter({tableName:"self_registration_establishments", conditions:[{key:"em_id",value:row.id}]})
                                const {data:{rows:self_reg_site}} = await visualizeWithFilter({tableName:"self_registration_sites", conditions:[{key:"em_id",value:row.id}]})
                                const {data:{rows:self_reg_warehouse_vat}} = await visualizeWithFilter({tableName:"self_reg_warehouse_vat", conditions:[{key:"em_id",value:row.id}]})
                                const {data:{rows:self_reg_document}} = await visualizeWithFilter({tableName:"self_reg_document", conditions:[{key:"em_id",value:row.id}]})

                                setComplete({id:row.id,visible: true, data: {...row,self_reg_document,self_reg_establishment,self_reg_site,self_reg_warehouse_vat}})

                            }}>View</Button>
                        }
                    })
                }

                return {data:{statusCode, rows:rows2, fields}};
            }}
            fetchData={async ()=>{
                if(filters.payload.length===0){
                    return await visualize("self_registration")
                } else {
                    return await visualizeWithFilters("self_registration", filters.payload)
                }
            }}
            shouldRefresh={(o, status)=>status}
            minColumnWidth={120}
            scroll={{y: 'calc(90vh - 40px)', x: 'max-content' }}
            action={null}
        >
            <TableContext.Consumer>
                {table => ci.visible && <Modal
                    centered={true}
                    closable={true}
                    key={ci}
                    width={940}
                    onCancel={() => {
                        setComplete({ id: -1, visible: false, data: {} });
                    }}
                    visible={ci.visible}
                    title={`Application-${`${ci.id}`.padStart(6, '0')}`}
                    footer={null}
                >
                    <Application
                        data={ci.data}
                        fetchConfig={async ({ schema }) => {
                            const { data: { rows = [] } } = await getFeConfig(schema)
                            return rows;
                        }}
                        onOSSRegComplete={async ()=>{
                            const {data: {rows = []}} = await table.props.fetchData() || {};
                            table.setData(rows)
                            return onStateChange();
                        }}
                        onOSSRegRequest={async ()=>{
                            const {data: {rows = []}} = await table.props.fetchData() || {};
                            table.setData(rows)
                            return onStateChange();
                        }}
                        onApprove={async ()=>{
                            const {data: {rows = []}} = await table.props.fetchData() || {};
                            table.setData(rows)
                            return onStateChange();
                        }}
                        onReject={async ()=>{
                            const {data: {rows = []}} = await table.props.fetchData() || {};
                            table.setData(rows)
                            return onStateChange();
                        }}
                    />
                </Modal>}
            </TableContext.Consumer>
        </TableV2>}



    </React.Fragment>
}
